import React from "react";
import { Link } from "react-router-dom";
import { Question, Lightning, Star, CreditCard, ArrowRight } from "@phosphor-icons/react";
import MarketingShell from "@/components/MarketingShell";

const FAQS = [
  { q: "How do I get my business listed?", a: "Add your business, then use Bulk Assist or the per-directory content generator to submit your listing across directories. Paste the live listing URL and CiteHub auto-marks it Live." },
  { q: "What are the AI platform listings?", a: "We help you get your business surfaced by ChatGPT, Perplexity, Google AI Overviews, Copilot and more — plus a LocalBusiness schema generator and an AI Readiness Score with fix-it steps." },
  { q: "How does billing work?", a: "Access requires a paid subscription billed monthly via Stripe. You can cancel anytime from your account menu. See our Cancellation & Refund Policy for details." },
  { q: "Can agencies manage multiple businesses?", a: "Yes. Add as many businesses as you like, track each one's progress separately, and export citation status to CSV for client reporting." },
];

const ICONS = [Lightning, Star, CreditCard, Question];

export default function Support() {
  return (
    <MarketingShell title="Support" subtitle="Answers to common questions — and how to reach a human.">
      <div className="grid gap-4">
        {FAQS.map((f, i) => {
          const Icon = ICONS[i % ICONS.length];
          return (
            <div key={f.q} className="rounded-xl border border-slate-200 bg-white p-6" data-testid={`faq-${i}`}>
              <div className="flex items-start gap-3">
                <div className="h-9 w-9 rounded-md bg-blue-50 flex items-center justify-center shrink-0"><Icon weight="duotone" size={20} className="text-[#0055FF]" /></div>
                <div>
                  <h3 className="font-display font-bold text-slate-900">{f.q}</h3>
                  <p className="text-sm text-slate-600 mt-1 leading-relaxed">{f.a}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-8 rounded-2xl border border-slate-200 bg-slate-50 p-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h3 className="font-display text-lg font-bold text-slate-900">Still need help?</h3>
          <p className="text-sm text-slate-600 mt-1">Send us a message and we'll respond within 1–2 business days.</p>
        </div>
        <Link to="/contact" data-testid="support-contact-link"
          className="inline-flex items-center gap-1.5 rounded-md bg-[#0055FF] hover:bg-[#0044CC] text-white font-semibold h-11 px-6 shrink-0">
          Contact support <ArrowRight size={17} />
        </Link>
      </div>
    </MarketingShell>
  );
}
